var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55556 5.76714H9M4.55556 8.80078H11.6667M6.94111 14.0013H12.7333C14.2268 14.0013 14.9735 14.0013 15.544 13.7179C16.0457 13.4686 16.4537 13.0708 16.7094 12.5815C17 12.0253 17 11.2972 17 9.84089V5.16042C17 3.70413 17 2.97599 16.7094 2.41977C16.4537 1.9305 16.0457 1.53271 15.544 1.28341C14.9735 1 14.2268 1 12.7333 1H5.26667C3.77319 1 3.02646 1 2.45603 1.28341C1.95426 1.53271 1.54631 1.9305 1.29065 2.41977C1 2.97599 1 3.70413 1 5.16042V16.0256C1 16.4875 1 16.7184 1.09709 16.837C1.18153 16.9401 1.30957 17.0001 1.44492 17C1.60056 16.9998 1.78548 16.8556 2.15534 16.5671L4.27574 14.913C4.7089 14.5751 4.92548 14.4061 5.16665 14.286C5.38062 14.1794 5.60838 14.1015 5.84375 14.0544C6.10904 14.0013 6.3864 14.0013 6.94111 14.0013Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.c6eb64c20d1d7c76732efa0cd1ab40b8.svg";
export { ForwardRef as ReactComponent };